/**
 *  HTTPError custom error
 */

export default class HTTPError extends Error {
  public statusCode: number;

  public constructor(statusCode: number, message: string) {
    if (!new.target) {
      throw new Error('HTTPError() must be called with new');
    }

    super(message || 'HTTP error');

    // Set the prototype explicitly.
    Object.setPrototypeOf(this, HTTPError.prototype);

    this.name = 'HTTPError';
    this.statusCode = statusCode;

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, HTTPError);
    }
  }
}
